import { data as developmentBlogData } from '@/profiles/development.blog.js';
import { data as developmentResourcesData } from '@/profiles/development.resources.js';
import { data as proxyBlogData } from '@/profiles/proxy.blog.js';

import { data as previewData } from '@/profiles/preview.js';
// import { data as previewOverideData } from '@/profiles/preview-override.js'; // Common Preview settings instead of duplicating in each profile
import { data as qaData } from '@/profiles/qa.js';

// Add each site profile here
import { data as corpBlogData } from '@/profiles/corporate.blog.js';
import { data as corpBlogDraftData } from '@/profiles/corporate.blog.draft.js';

import { data as constBlogData } from '@/profiles/construction.blog.js';
import { data as constBlogDraftData } from '@/profiles/construction.blog.draft.js';

import { data as constResourcesData } from '@/profiles/construction.resources.js';
import { data as constResourcesDraftData } from '@/profiles/construction.resources.draft.js';

import { data as sketchupBlogData } from '@/profiles/sketchup.blog.js';
import { data as sketchupBlogDraftData } from '@/profiles/sketchup.blog.draft.js';
import { data as sketchupResourcesData } from '@/profiles/sketchup.resources.js';
import { data as sketchupResourcesDraftData } from '@/profiles/sketchup.resources.draft.js';
import { data as geospatialBlogData } from '@/profiles/geospatial.blog.js';
import { data as geospatialBlogDraftData } from '@/profiles/geospatial.blog.draft.js';
import { data as geospatialResourcesData } from '@/profiles/geospatial.resources.js';
import { data as geospatialResourcesDraftData } from '@/profiles/geospatial.resources.draft.js';
import { data as opsBlogData } from '@/profiles/ops.blog.js';
import { data as opsBlogDraftData } from '@/profiles/ops.blog.draft.js';
import { data as opsResourcesData } from '@/profiles/ops.resources.js';
import { data as opsResourcesDraftData } from '@/profiles/ops.resources.draft.js';
import { data as positioningBlogData } from '@/profiles/positioning.blog.js';
import { data as positioningBlogDraftData } from '@/profiles/positioning.blog.draft.js';
import { data as positioningResourcesData } from '@/profiles/positioning.resources.js';
import { data as positioningResourcesDraftData } from '@/profiles/positioning.resources.draft.js';

import { data as applanixBlogData } from '@/profiles/applanix.blog.js';
import { data as applanixBlogDraftData } from '@/profiles/applanix.blog.draft.js';
import { data as applanixResourcesData } from '@/profiles/applanix.resources.js';
import { data as applanixResourcesDraftData } from '@/profiles/applanix.resources.draft.js';

import { data as oemgnssBlogData } from '@/profiles/oemgnss.blog.js';
import { data as oemgnssBlogDraftData } from '@/profiles/oemgnss.blog.draft.js';
import { data as oemgnssResourcesData } from '@/profiles/oemgnss.resources.js';
import { data as oemgnssResourcesDraftData } from '@/profiles/oemgnss.resources.draft.js';

export const getProfile = (profile = 'all') => {
  const profileMapping = {
    'development-blog': developmentBlogData,
    'development-resources': developmentResourcesData,

    'corporate-blog': corpBlogData,
    'corporate-blog-draft': corpBlogDraftData,

    'construction-blog': constBlogData,
    'construction-blog-draft': constBlogDraftData,
    'construction-resources': constResourcesData,
    'construction-resources-draft': constResourcesDraftData,

    'applanix-blog': applanixBlogData,
    'applanix-blog-draft': applanixBlogDraftData,
    'applanix-resources': applanixResourcesData,
    'applanix-resources-draft': applanixResourcesDraftData,
    'oemgnss-blog': oemgnssBlogData,
    'oemgnss-blog-draft': oemgnssBlogDraftData,
    'oemgnss-resources': oemgnssResourcesData,
    'oemgnss-resources-draft': oemgnssResourcesDraftData,
    
    'sketchup-blog': sketchupBlogData,
    'sketchup-blog-draft': sketchupBlogDraftData,
    'sketchup-resources': sketchupResourcesData,
    'sketchup-resources-draft': sketchupResourcesDraftData,
    'geospatial-blog': geospatialBlogData,
    'geospatial-blog-draft': geospatialBlogDraftData,
    'geospatial-resources': geospatialResourcesData,
    'geospatial-resources-draft': geospatialResourcesDraftData,
    'ops-blog': opsBlogData,
    'ops-blog-draft': opsBlogDraftData,
    'ops-resources': opsResourcesData,
    'ops-resources-draft': opsResourcesDraftData,
    'positioning-blog': positioningBlogData,
    'positioning-blog-draft': positioningBlogDraftData,
    'positioning-resources': positioningResourcesData,
    'positioning-resources-draft': positioningResourcesDraftData,

    'preview': previewData,
    'qa': qaData,
    'proxy': proxyBlogData,
  };

  const additionalEnvVariables = [
    "EXTRA_ENV_VAR",
  ]

  // if a value is in env then use it. Also those env values need to be cast as boolean or number if needed.
  const selectedProfile = profileMapping[profile] || developmentBlogData; // should this be 'developmentData' instead of 'developmentBlogData'? build errors out with it.
  Object.keys(selectedProfile).forEach((key) => {
    const envValue = process.env[key] || selectedProfile[key];
    if (envValue) {
      if(envValue === 'false' || envValue === false) {
        selectedProfile[key] = false;
      } else if(envValue === 'true' || envValue === true) {
        selectedProfile[key] = true;
      } else if(!isNaN(envValue)) {
        selectedProfile[key] = Number(envValue);
      } else {
        selectedProfile[key] = envValue;
      }
    }
  });
  for(const key of additionalEnvVariables) {
    const envValue = process.env[key] || selectedProfile[key];
    if (envValue) {
      selectedProfile[key] = envValue;
    }
  }

  return selectedProfile;
}

const layerProfiles = (profile1, profile2) => {
  for(const key of additionalEnvVariables) {
    const envValue = process.env[key] || selectedProfile[key];
    if (envValue) {
      selectedProfile[key] = envValue;
    }
  }
}